import { useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import FindingForm from "@/components/forms/findingForm";
import { usePageHeading } from "@/helper/customHooks/usePageHeading";

export default function Form() {
  const { t } = useTranslation();
  const [formTitle, setFormTitle] = useState<string>("");
  const { findingId, formId } = useParams();
  const heading = formTitle || t("form");
  usePageHeading(heading);

  const onFormTitleChange = function (newTitle: string) {
    setFormTitle(newTitle);
  };

  return (
    <div>
      <div>
        <FindingForm
          findingId={findingId}
          formId={formId}
          onFormTitleChange={onFormTitleChange}
          onCancelFormHandler={() => ""}
          onSuccessfulFormSubmitHandler={() => ""}
        />
      </div>
    </div>
  );
}
